var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgE = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 12",
  viewBox: "0 0 200 200"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "E_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h200v200H0z",
  "data-name": "Rectangle 20"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 11",
  style: {
    clipPath: "url(#E_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M200 100A100 100 0 1 1 100 0a100 100 0 0 1 100 100",
  "data-name": "Path 6"
}))));
export default SvgE;